import { useState } from "react";
import axios from "axios";
import useCurrentUser from "./useCurrentUser";
import {
  removeAccessToken,
  removeRefreshToken,
  setAccessToken,
  setRefreshToken,
} from "../storage/storage";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function useLogin() {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { getCurrentUser } = useCurrentUser();
  const [loading, setLoading] = useState(false);

  const Login = async (payload, next = "/") => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/api/login/`, payload);

      setAccessToken(response.data.access);
      setRefreshToken(response.data.refresh);
      getCurrentUser(response.data.access);
      setLoading(false);
      window.location.href = next;
      return true;
    } catch (error) {
      if (error.response?.status === 403) {
        navigate("/otp-verify", {
          state: {
            email: payload.email,
          },
        });
      }

      setLoading(false);
      Swal.fire({
        icon: "error",
        text:
          error?.response?.data?.message ||
          "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
        customClass: {
          confirmButton: "custom-red-button",
        },
      });
      return false;
    }
  };

  const Logout = () => {
    removeAccessToken();
    removeRefreshToken();
    window.location.href = "/";
  };
  return { Login, Logout, loading };
}
export default useLogin;
